import React from 'react'

// css
import 'assets/style/elements/input-checkbox.scss'

function Element({
  name = '',
  title,
  value,
  checked = false,
  className,
  onChange = () => {},
  onChangeObj = () => {},
  styleYn = false,
  disabled = false,
}) {
  return (
    <label className={styleYn ? 'input-checkbox-lg ' + className : 'input-checkbox ' + className}>
      <input
        name={name}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={(e) => {
          onChange(e)
          onChangeObj(e, { value: value, title: title })
        }}
        disabled={disabled}
      />
      <span className="label">{title}</span>
    </label>
  )
}

export default Element
